import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngCookies from 'angular-cookies';

import routing from './group_report_show.routes';
import SaGroupService from '../../../components/api/sa_group/sa_group.service';

export class GroupReportShowController {
  /*@ngInject*/
  constructor($state, $stateParams, $cookies, SaGroupService) {
    this.id = $stateParams.id;
    this.cookies = $cookies;
    this.$state = $state;
    this.SaGroupService = SaGroupService;

    this.term = $stateParams.term || this.cookies.get('report_term') || 'daily';
  }

  $onInit() {
    this.SaGroupService.api.show({id: this.id}, response => {
      this.name = response.name;
      this.memo = response.memo;
    }, err => {
      if (err.status === 404 || err.status === 403) {
        this.$state.go('main.home');
      }
    });
  }

  changeTerm(term) {
    this.cookies.put('report_term', term);
    this.term = term;
  }
}

export default angular.module('leptonApp.groupReportShow', [uiRouter, ngCookies, SaGroupService])
  .config(routing)
  .component('groupReportShow', {
    template: require('./group_report_show.html'),
    controller: GroupReportShowController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/group_report/show/group_report_show.component.js